import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';

import { Heading } from '../../components';

import css from './ListingPage.module.css';

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = publicDataValue !== undefined ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && value != null) {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);
      const COMPANION_VALS = ['other', 'us_state', 'australian_state'];
      const enumDisplayValue =
        COMPANION_VALS.includes(value)
          ? publicData[`other_${key}`] || optionConfig?.label || value
          : optionConfig?.label || value;

      const displayLabel = label ? label.replace(/\bMinimal\b/g, 'Minimum') : label;

      const displayValue =
        schemaType === 'enum'
          ? enumDisplayValue
          : schemaType === 'multi-enum' && Array.isArray(value)
          ? value.map(v => {
              const opt = enumOptions?.find(o => `${o.option}` === `${v}`);
              return opt?.label || v;
            }).join(', ')
          : schemaType === 'boolean'
          ? getBooleanMessage(value)
          : value;

      return filteredConfigs.concat({ key, value: displayValue, label: displayLabel });
    }
    return filteredConfigs;
  };

  const allListingFields = listingFieldConfigs.reduce(pickListingFields, []);

  // If minimum_experience_required is truthy → hide the redundant boolean row, keep experience value.
  const minExpReq = publicData?.minimum_experience_required;
  const isMinExpRequired = !!minExpReq && minExpReq !== 'no' && minExpReq !== 'false';
  const existingListingFields = allListingFields.filter(f => {
    if (f.key === 'minimum_experience_required' && isMinExpRequired) return false;
    return true;
  });

  return existingListingFields.length > 0 ? (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading>
      <ul className={css.details}>
        {existingListingFields.map(detail => (
          <li key={detail.key} className={css.detailsRow}>
            <span className={css.detailLabel}>{detail.label}</span>
            <span>{detail.value}</span>
          </li>
        ))}
      </ul>
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
